import { render, staticRenderFns } from "./DelPersonList.vue?vue&type=template&id=8cb84994&scoped=true"
import script from "./DelPersonList.vue?vue&type=script&lang=js"
export * from "./DelPersonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb84994",
  null
  
)

export default component.exports